import { ReactElement, memo } from 'react';
import { Stack, Typography } from '@mui/material';

import { OrderHistoryEventInfoProps } from './types';

const OrderHistoryEventInfo = ({
  title,
  description,
}: OrderHistoryEventInfoProps): ReactElement => (
  <Stack spacing={0.5}>
    <Typography variant="body2" fontWeight="bold">
      {title}
    </Typography>

    <Typography variant="caption" color="text.secondary">
      {description}
    </Typography>
  </Stack>
);

export default memo(OrderHistoryEventInfo);
